export const envKeys = {
  all: ['env'] as const,
  // Not scoped to a company or an organization: the value is the caller's own
  // network address and does not change when the token is switched.
  userIP: () => [...envKeys.all, 'userIP'] as const,
  companyUserPreferences: (companyId: string) => [...envKeys.all, 'companyUserPreferences', companyId] as const,
};
